<template>
  <section class="container">
    <div class="header"
      :style="{backgroundImage:'url(' + require('@/assets/payment-related/payment1564@2x.png') + ')'}">
      <div class="header__info">
        <span class="header__info__title">{{
          $enumObject.providerConfig[config.projectName].provider.providerName
        }}</span>
        <span class="header__info__content">-{{
            $enumObject.providerConfig[config.projectName].provider.propagandaInfo
          }}-</span>
      </div>
    </div>
    <h3 class="prompt_tips">请输入车牌号预约停车</h3>
    <div class="page page-index">
      <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
    </div>
    <h3 class="prompt_tips">请选择停车场</h3>
    <van-field readonly clickable :value="value" placeholder="请选择停车场" @click="showPicker = true" center='true' />

    <van-popup v-if="showPicker" v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
    <div class="btn_box">
      <van-button @click="submit" size="large" class="blue-btn">
        预约停车
      </van-button>
    </div>

  </section>
</template>

<script>
import keyboard from '@/components/keyboard/index'
import { getUrlParam } from '@/utils'
import config from '@/config/index'
import { Picker, Field, Popup } from 'vant'
import { mapGetters } from 'vuex'
export default {
  name: 'Parking-Reservation',
  components: { keyboard, [Picker.name]: Picker, [Field.name]: Field, [Popup.name]: Popup },
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: [],
      value: '',
      showPicker: false,
      columns: ['夹岗双龙科技产业园停车场	', '微信支付停车场'],
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token'])
  },
  methods: {
    onConfirm (value) {
      this.value = value;
      this.showPicker = false;
    },

    change (val) {
      this.plateNumber = val
    },
    submit () {
      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      let params = {
        cardNumber: _this.plateNumber.join(''),
        parkId: getUrlParam('parkId')
      }
      // this.$store.commit('transaction/SET_BILL_PARAMS', params)
      this.$router.push({
        name: 'ReservationResult',
        query: {
          result: 'success'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  /deep/ .van-field__control {
    text-align: center;
  }

  .header {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: px2rem(140);
    min-height: px2rem(140);
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &__info {
      width: 70%;
      height: 50%;
      display: flex;
      flex-direction: colunm;
      flex-wrap: wrap;
      align-items: center;

      span {
        color: #fff;
        text-align: center;
      }

      &__title {
        width: 100%;
        font-size: 22px;
        font-weight: 500;
      }

      &__content {
        width: 100%;
        font-size: 18px;
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    text-align: center;
  }

  .page {
    padding: px2rem(15);
    margin: px2rem(10) 0 px2rem(20);
  }

  .btn_box {
    padding: 0 15px;
  }
}
</style>